'use client';
import { DesignSystemError } from '@s7/system';
import { isHex, isRGBA, isRGB } from '../validators/validators.js';

function hexToRgba(color) {
    let hexString = color.replace('#', '');
    if (hexString.length === 3 || hexString.length === 4) {
        hexString = hexString.split('').map((char)=>`${char}${char}`).join('');
    }
    if (hexString.length !== 6 && hexString.length !== 8) {
        console.warn(new DesignSystemError('styles', 'Невалидный hex формат. Должно быть 3,4,6 или 8 символов.'));
        return {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        };
    }
    let r, g, b, a = 255;
    const parsed = parseInt(hexString, 16);
    if (hexString.length === 8) {
        r = parsed >> 24 & 255;
        g = parsed >> 16 & 255;
        b = parsed >> 8 & 255;
        a = parsed >> 0 & 255;
    } else {
        r = parsed >> 16 & 255;
        g = parsed >> 8 & 255;
        b = parsed >> 0 & 255;
    }
    const normalizedAlpha = Math.ceil(a * 100 / 255) / 100;
    return {
        r,
        g,
        b,
        a: normalizedAlpha
    };
}
const parseRGBA = (color)=>{
    const [r, g, b, a] = color.replace(/[^0-9,.]/g, '').split(',').map(Number);
    return {
        r,
        g,
        b,
        a: a || 1
    };
};
const toRGBA = (color)=>{
    if (color === 'transparent') {
        return {
            r: 0,
            g: 0,
            b: 0,
            a: 0
        };
    }
    if (isHex(color)) {
        return hexToRgba(color);
    }
    if (isRGBA(color) || isRGB(color)) {
        return parseRGBA(color);
    }
    return {
        r: 0,
        g: 0,
        b: 0,
        a: 1
    };
};

export { toRGBA };
//# sourceMappingURL=toRGBA.js.map
